import { Component, Vue, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';

@Component({})
export default class OCAccordion extends Mixins(BASEComponentVue) {

    @Prop({
        type: String,
        default: "",
    })
    public title!: string;

    @Prop({
        type: Boolean,
        default: false,
    })
    public isDefaultOpen!: boolean;

    public isOpen: boolean = false;
    public created(){
        this.isOpen = this.isDefaultOpen ? this.isDefaultOpen : false;
    }
}
